import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Images } from "../../../../assets/assets";
import "./Utilities.css";
import { useUtilityStore } from "../../../../store/useUtitlityStore";
import { useState } from "react";
import Loader from "../../../Loader";

export default function UtilitiesServices() {
    const { getUtility, utility } = useUtilityStore()
    const [loading, setLoading] = useState(false)

    const getFetchedEartWork = async () => {
        setLoading(true)
        await getUtility(1, 5, '', '')
        setLoading(false)
    }

    useEffect(() => {
        if (utility.length > 0)
            return
        getFetchedEartWork()
    }, [])
    return (
        <div className="earthworkservices-page mt-5">
            <Loader loading={loading}>
                {
                    (utility || []).map((ele, i) => {
                        return (
                            <section className="earthworkservices-section1 py-5 mb-xl-4 mb-3" key={i}>
                                <Container className="theme-container">
                                    <Row className={`service-block align-items-center ${i % 2 !== 0 && `flex-lg-row-reverse`}`}>
                                        <Col lg={6}>
                                            <p className="section-subtitle">{ele?.subTitle}</p>
                                            <h4 className="title mb-xl-4 mb-3">{ele?.title}</h4>
                                            <p className="mb-xl-4 mb-3">
                                                {ele?.description?.split("\n").map((line, idx) => (
                                                    <span key={idx}>
                                                        {line} <br />
                                                    </span>
                                                ))}
                                            </p>

                                        </Col>
                                        <Col lg={6}>
                                            <div className="img-wrapper">
                                                <div className="img-wraper-2">
                                                    <img className="img-fluid" src={ele?.image} alt="earth work image" />
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                            </section>
                        )
                    })
                }
            </Loader>
        </div>
    );
}
